import config from '@/config';
import useCache from '@/hooks/useCache';
import useTranslations from '@/i18n/useTranslations';
import Loader from '@/shared-components/loader/Loader';  // ✅ Updated import
import ActivityHeading from '@/shared-components/text/components/ActivityHeading';
import Text from '@/shared-components/text/components/Text';
import { filterRenderablePosts } from '@/utils/activityContent';

import VirtualList from './components/VirtualList';

import './index.css';

export default function LikedPosts() {
  const t = useTranslations('common.profile.activity');
  const { loading, fetchData, loadMoreData } = useCache("liked_posts", `${config.apis.api.url}/posts/liked`, {
    injectToken: true,
    invalidateWhen: ["LIKE_POST"],
    includeSearchQueries: {
      content: 'posts',
    },
  });
  const safeFetchData = fetchData ?? { data: [], totalDocs: 0 };
  const postsOnly = filterRenderablePosts(safeFetchData.data);

  return (
    <>
      <ActivityHeading text={t('menu.liked_posts')}/>
      <div className="activity-liked-posts__container">
        {
          loading ? 
            <Loader/>  // ✅ Updated to use the global Loader
            : postsOnly.length === 0 ? 
              <Text className="activity-liked-posts__text font-size-medium">
                {t('empty.liked_posts')}
              </Text>
              :
              <VirtualList items={{
                ...safeFetchData,
                data: postsOnly,
                totalDocs: typeof safeFetchData.totalDocs === 'number' ? safeFetchData.totalDocs : postsOnly.length
              }} onLoadMore={loadMoreData}/>
        }
      </div>
    </>
  );
}
